export default "__VITE_ASSET__DT7F5MmV__"